import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import SkeletonField from './SkeletonField'
import SkeletonTable from './SkeletonTable'

export type SkeletonTermsRulesProps = {
    rules?: number
    versions?: number
}

const MiniTable = ({ columns, rows }: { columns: number; rows: number }) => (
    <Box>
        <Stack direction="row" spacing={3} sx={{ mb: 1 }}>
            {Array.from({ length: columns }, (_, index) => (
                <Skeleton key={index} variant="text" width={`${Math.floor(90 / columns)}%`} />
            ))}
        </Stack>
        {Array.from({ length: rows }, (_, row) => (
            <Stack
                key={row}
                direction="row"
                spacing={3}
                sx={{ py: 0.75, bgcolor: row % 2 === 0 ? 'action.hover' : 'transparent', px: 1 }}
            >
                {Array.from({ length: columns }, (_, index) => (
                    <Skeleton key={index} variant="text" width={`${Math.floor(80 / columns)}%`} />
                ))}
            </Stack>
        ))}
    </Box>
)

export default function SkeletonTermsRules(props: Readonly<SkeletonTermsRulesProps>) {
    const { rules = 1, versions = 4 } = props

    return (
        <Grid container spacing={2} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Skeleton variant="text" width={140} sx={{ fontSize: '1.5rem' }} />
                </Paper>
            </Grid>

            {Array.from({ length: rules }, (_, rule) => (
                <Grid key={rule} size={12}>
                    <Paper sx={{ p: 3 }}>
                        <Stack
                            direction="row"
                            spacing={3}
                            sx={{
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                borderBottom: '1px solid',
                                borderColor: 'divider',
                                pb: 1.5,
                                mb: 3,
                            }}
                        >
                            <Stack direction="row" spacing={4} sx={{ flexWrap: 'wrap', rowGap: 1 }}>
                                {Array.from({ length: versions }, (_, index) => (
                                    <Stack key={index} spacing={0.5}>
                                        <Skeleton variant="text" width={110} />
                                        <Skeleton variant="text" width={80} />
                                    </Stack>
                                ))}
                                <Skeleton variant="text" width={90} />
                            </Stack>
                            <Stack direction="row" spacing={1.5}>
                                <Skeleton variant="circular" width={22} height={22} />
                                <Skeleton variant="circular" width={22} height={22} />
                            </Stack>
                        </Stack>

                        <Grid container spacing={3} rowSpacing={3}>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <SkeletonField />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <SkeletonField />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <SkeletonField />
                            </Grid>

                            <Grid size={{ xs: 12, md: 6 }}>
                                <Skeleton variant="text" width={60} sx={{ mb: 1 }} />
                                <MiniTable columns={3} rows={3} />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Skeleton variant="text" width={90} sx={{ mb: 1 }} />
                                <MiniTable columns={2} rows={2} />
                            </Grid>

                            <Grid size={12}>
                                <Skeleton variant="text" width={80} sx={{ mb: 1 }} />
                                <SkeletonTable rows={3} columns={7} showToolbar={false} />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    )
}
